module.exports = __webpack_public_path__ + "static/img/download_google.c78f3dc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/download_google.png
// module id = 2FJ1
// module chunks = 1